<div class="objectives-content__trips">
  <div class="title-container">
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
    >
      <path
        d="M8 1.5C6.71442 1.5 5.45772 1.88122 4.3888 2.59545C3.31988 3.30968 2.48676 4.32484 1.99479 5.51256C1.50282 6.70028 1.37409 8.00721 1.6249 9.26809C1.8757 10.529 2.49477 11.6872 3.40381 12.5962C4.31285 13.5052 5.47104 14.1243 6.73192 14.3751C7.99279 14.6259 9.29973 14.4972 10.4874 14.0052C11.6752 13.5132 12.6903 12.6801 13.4046 11.6112C14.1188 10.5423 14.5 9.28558 14.5 8C14.4982 6.27665 13.8128 4.62441 12.5942 3.40582C11.3756 2.18722 9.72335 1.50182 8 1.5ZM13.5 8C13.5005 8.70561 13.3647 9.40468 13.1 10.0588L10.3063 8.34062C10.1875 8.26733 10.0546 8.21984 9.91625 8.20125L8.49 8.00875C8.29347 7.98312 8.09375 8.01607 7.91586 8.10346C7.73798 8.19084 7.58983 8.32879 7.49 8.5H6.945L6.7075 8.00875C6.64184 7.87196 6.54575 7.75201 6.42659 7.65809C6.30742 7.56417 6.16834 7.49876 6.02 7.46688L5.52 7.35875L6.00875 6.5H7.05313C7.22212 6.49967 7.3883 6.45667 7.53625 6.375L8.30188 5.9525C8.36914 5.915 8.43203 5.87015 8.48938 5.81875L10.1713 4.2975C10.3399 4.14638 10.452 3.9423 10.489 3.71892C10.526 3.49554 10.4858 3.26621 10.375 3.06875L10.3525 3.02813C11.2936 3.47437 12.0889 4.17837 12.646 5.05841C13.2031 5.93845 13.4993 6.95844 13.5 8ZM8.95688 2.58375L9.5 3.55625L7.81813 5.0775L7.05313 5.5H6.00875C5.83297 5.49974 5.66022 5.54582 5.50792 5.63361C5.35562 5.72139 5.22915 5.84776 5.14125 6L4.59563 6.95188L3.96125 5.26188L4.645 3.645C5.25022 3.17737 5.94643 2.84131 6.68905 2.65835C7.43167 2.47538 8.20432 2.44955 8.9575 2.5825L8.95688 2.58375ZM2.5 8C2.49917 7.18251 2.68155 6.37523 3.03375 5.6375L3.7425 7.52938C3.80157 7.68602 3.89901 7.82532 4.0259 7.93452C4.15279 8.04372 4.30506 8.11931 4.46875 8.15438L5.80813 8.4425L6.04625 8.9375C6.12889 9.10586 6.25697 9.24775 6.416 9.34715C6.57504 9.44655 6.75871 9.49949 6.94625 9.5H7.03875L6.58688 10.5144C6.50726 10.693 6.48176 10.891 6.51353 11.084C6.5453 11.2769 6.63295 11.4563 6.76563 11.6L6.77438 11.6088L8 12.8713L7.87875 13.4963C6.4424 13.4628 5.07598 12.8694 4.07108 11.8425C3.06618 10.8157 2.50239 9.43674 2.5 8ZM8.91125 13.4237L8.98188 13.0606C9.0109 12.9064 9.00341 12.7474 8.96 12.5966C8.91659 12.4457 8.83846 12.3071 8.73188 12.1919C8.72881 12.1891 8.72589 12.1862 8.72313 12.1831L7.5 10.9213L8.35625 9L9.7825 9.1925L12.64 10.95C12.226 11.6001 11.6803 12.1562 11.038 12.5823C10.3957 13.0084 9.6712 13.2951 8.91125 13.4237Z"
        fill="#099831"
      />
    </svg>
    <h2 class="heading-h2">Viagens</h2>
  </div>

  <div class="trips-reason">
    <h3 class="heading-h3">Escolheu esse objetivo porque</h3>
    <p>
      {{ dataStoreTrips.description }}
    </p>

    <h3 class="heading-h3">Quando deseja realizar esse objetivo?</h3>
    <p>{{ intendDate }}</p>
  </div>

  <div class="trips-reason">
    <h3 class="heading-h3">Quanto pretende investir nesse objetivo?</h3>
    <div class="pretend-invest-container">
      <div class="invest__min">
        <h4 class="heading-h4">Minimo</h4>
        <p>{{ minInvestimentFormated }} /mês</p>
      </div>
      <div class="invest__max">
        <h4 class="heading-h4">Maximo</h4>
        <p>{{ maxInvestimentFormated }} /mês</p>
      </div>
    </div>
    <div>
      <h3 class="heading-h3">Observações</h3>
      <p>
        {{ dataStoreTrips.observation }}
      </p>
    </div>
  </div>
</div>
